<template>
  <div>
    <transition appear name="popup-bg-fade">
      <bottomcheckboxes v-if="showPopup && activeTheme === 'bottom-checkboxes'"></bottomcheckboxes>
    </transition>

    <transition appear name="popup-slide-up">
      <simplebottom v-if="showPopup && activeTheme === 'simple'"></simplebottom>
    </transition>

    <transition appear name="blocking-popup-fade">
      <blockingpopup v-if="showPopup && activeTheme === 'blocking'"></blockingpopup>
    </transition>

    <transition appear name="friendly-popup-fade">
      <friendlypopup v-if="showPopup && activeTheme === 'friendly-popup'"></friendlypopup>
    </transition>
  </div>
</template>

<script>
//mixins
import CookieModuleMixin from '../mixins/CookieModuleMixin.js'

export default {
  mixins: [CookieModuleMixin],
  name: 'CookiePopups',
};
</script>

<style lang="scss">
//bottom checkboxes transition
.popup-bg-fade-enter-active, .popup-bg-fade-leave-active {
  transition: background 0.5s ease-out;

  .cookie-wrapper {
    transition: bottom 0.5s ease-out;
  }
}

.popup-bg-fade-enter, .popup-bg-fade-leave-to {
  background: rgba(0, 0, 0, 0) !important;

  .cookie-wrapper {
    bottom: -250px !important;
  }
}

.popup-bg-fade-enter-to, .popup-bg-fade-leave {
  background: rgba(0, 0, 0, 0.75) !important;

  .cookie-wrapper {
    bottom: 0px !important;
  }
}

//popup slide up
.popup-slide-up-enter-active, .popup-slide-up-leave-active {
  transition: bottom 0.5s ease-out;
}

.popup-slide-up-enter, .popup-slide-up-leave-to {
  bottom: -100px !important;
}

.popup-slide-up-enter-to, .popup-slide-up-leave {
  bottom: 0px !important;
}

//friendly popup show transition
.friendly-popup-fade-enter-active, .friendly-popup-fade-leave-active {
  transition: background 0.5s ease-out;

  .friendly-popup-wrapper {
    transition: top 0.3s ease-out, opacity 0.3s ease-out;
  }
}

.friendly-popup-fade-enter, .friendly-popup-fade-leave-to {
  background: rgba(0, 0, 0, 0) !important;

  .friendly-popup-wrapper {
    top: 125px !important;
    opacity: 0 !important;
  }
}

.friendly-popup-fade-enter-to, .friendly-popup-fade-leave {
  background: rgba(0, 0, 0, 0.5) !important;

  .friendly-popup-wrapper {
    top: 100px !important;
    opacity: 1 !important;
  }
}

//friendly popup show transition
.blocking-popup-fade-enter-active, .blocking-popup-fade-leave-active {
  .full-screen-cookie-popup__overlay {
    transition: background 0.5s ease-out;
  }

  .full-screen-cookie-popup__popup {
    transition: transform 0.3s ease-out, opacity 0.3s ease-out;
  }
}

.blocking-popup-fade-enter, .blocking-popup-fade-leave-to {
  .full-screen-cookie-popup__overlay {
    background: rgba(0, 0, 0, 0) !important;
  }

  .full-screen-cookie-popup__popup {
    transform: translateY(25px) !important;
    opacity: 0 !important;
  }
}

.blocking-popup-fade-enter-to, .blocking-popup-fade-leave {
  .full-screen-cookie-popup__overlay {
    background: rgba(0, 0, 0, 0.5) !important;
  }

  .full-screen-cookie-popup__popup {
    transform: translateY(0px) !important;
    opacity: 1 !important;
  }
}
</style>